import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CreditCard, Star, Users, BookOpen, MapPin } from 'lucide-react';
export function Hero() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative pt-12 pb-10 md:pt-24 md:pb-16 overflow-hidden bg-brand-dark" data-id="element-173">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-brand-light/40 via-brand-dark to-brand-dark -z-10" data-id="element-174"></div>

      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-175">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-12 items-center" data-id="element-176">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="text-center lg:text-left" data-id="element-177">
            

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-display font-black leading-tight mb-4 text-white" data-id="element-178">
              Todo tu año de Stretching{' '}
              <span className="text-brand-accent" data-id="element-179">resuelto.</span>
            </h1>

            {/* Product image — mobile only, between title and subtitle */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.15
          }} className="relative my-4 lg:hidden flex justify-center" data-id="element-180">
              <div className="absolute inset-0 bg-brand-accent/15 blur-[80px] rounded-full" data-id="element-181"></div>
              <img src="https://cdn.magicpatterns.com/uploads/6v8hWDxBGVUVdp8w8UxKgG/stretch-Photoroom.png" alt="Megapack Stretching Resuelto" className="relative z-10 w-[70%] max-w-xs mx-auto drop-shadow-2xl" data-id="element-182" />
            </motion.div>

            <p className="text-base md:text-xl text-gray-300 mb-4 font-medium" data-id="element-183">
              6 Tomos · 60+ Clases · 6 Bonos · Listo para usar.
            </p>

            <p className="text-sm md:text-lg text-gray-400 mb-6 max-w-xl mx-auto lg:mx-0" data-id="element-184">
              Tu año completo de Stretching listo: clases, técnica, progresión,
              poblaciones especiales, gestión y comunicación. Sin improvisar.
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-2 mb-6" data-id="element-185">
              <span className="flex items-center text-xs sm:text-sm bg-brand-light px-2.5 py-1 rounded-md text-gray-200" data-id="element-186">
                <BookOpen className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-187" />{' '}
                PDF digital
              </span>
              <span className="flex items-center text-xs sm:text-sm bg-brand-light px-2.5 py-1 rounded-md text-gray-200" data-id="element-188">
                <Star className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-189" /> Acceso
                inmediato
              </span>
              <span className="flex items-center text-xs sm:text-sm bg-brand-light px-2.5 py-1 rounded-md text-gray-200" data-id="element-190">
                <Users className="w-3.5 h-3.5 mr-1.5 text-brand-accent" data-id="element-191" /> Todos
                los niveles
              </span>
            </div>

            <motion.button whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} onClick={scrollToPricing} className="w-full sm:w-auto bg-brand-accent hover:bg-brand-accentHover text-brand-dark font-bold text-base md:text-xl px-6 py-4 rounded-xl shadow-[0_0_30px_rgba(45,212,191,0.4)] transition-all flex items-center justify-center" data-id="element-192">
              💥 → QUIERO MI STRETCHING RESUELTO AHORA
            </motion.button>

            <div className="mt-5 flex flex-wrap items-center justify-center lg:justify-start gap-4 text-xs sm:text-sm text-gray-400" data-id="element-193">
              <div className="flex items-center" data-id="element-194">
                <Shield className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-195" />
                Garantía 7 días
              </div>
              <div className="flex items-center" data-id="element-196">
                <Shield className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-197" />
                Pago 100% seguro
              </div>
              <div className="flex items-center" data-id="element-198">
                <CreditCard className="w-4 h-4 mr-1.5 text-brand-accent" data-id="element-199" />
                Mercado Pago | Tarjeta
              </div>
            </div>
          </motion.div>

          {/* Product image — desktop only */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative hidden lg:block" data-id="element-200">
            <div className="absolute inset-0 bg-brand-accent/20 blur-[100px] rounded-full" data-id="element-201"></div>
            <img src="https://cdn.magicpatterns.com/uploads/6v8hWDxBGVUVdp8w8UxKgG/stretch-Photoroom.png" alt="Megapack Stretching Resuelto" className="relative z-10 w-[70%] max-w-lg mx-auto drop-shadow-2xl" data-id="element-202" />
          </motion.div>
        </div>

        {/* Stats Row */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="mt-10 md:mt-16 grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-8 border-t border-brand-light pt-6 md:pt-10" data-id="element-203">
          <div className="text-center" data-id="element-204">
            <div className="text-2xl md:text-4xl font-display font-bold text-white mb-0.5" data-id="element-205">
              +500
            </div>
            <div className="text-brand-accent text-xs md:text-base font-medium" data-id="element-206">
              PROFES CONFÍAN
            </div>
          </div>
          <div className="text-center" data-id="element-207">
            <div className="text-2xl md:text-4xl font-display font-bold text-white mb-0.5" data-id="element-208">
              6+6
            </div>
            <div className="text-brand-accent text-xs md:text-base font-medium" data-id="element-209">
              TOMOS + BONOS
            </div>
          </div>
          <div className="text-center" data-id="element-210">
            <div className="text-2xl md:text-4xl font-display font-bold text-white mb-0.5 flex items-center justify-center" data-id="element-211">
              4.9/5{' '}
              <Star className="w-4 h-4 md:w-6 md:h-6 ml-1 text-yellow-400 fill-yellow-400" data-id="element-212" />
            </div>
            <div className="text-brand-accent text-xs md:text-base font-medium" data-id="element-213">
              CALIFICACIÓN
            </div>
          </div>
          <div className="text-center" data-id="element-214">
            <div className="text-2xl md:text-4xl font-display font-bold text-white mb-0.5 flex items-center justify-center" data-id="element-215">
              🇦🇷
            </div>
            <div className="text-brand-accent text-xs md:text-base font-medium" data-id="element-216">
              TODO EL PAÍS
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}